// extracted by mini-css-extract-plugin
export var button = "_fo-4";
export var hasDarkBackground = "_fo-7";
export var hasLightBackground = "_fo-6";
export var iconWrapper = "_fo-0";
export var large = "_fo-2";
export var medium = "_fo-1";
export var small = "_fo-5";
export var xsmall = "_fo-3";